import React from 'react';
export function Footer() {
  return <footer className="w-full bg-navy-900 px-5 pb-32 pt-12 text-center md:pb-28" data-id="element-169" data-mp="19ivlq3plplne">
      <p className="font-serif text-xl font-bold text-white" data-id="element-170" data-mp="206ri3faq3orp">Ortho Treatment Map™</p>
      <p className="mt-1 text-sm text-sky-light" data-id="element-171" data-mp="2f3sa7jwttlqp">Created by Dr. Nathan Brooks</p>
      <p className="mx-auto mt-4 max-w-lg text-sm leading-relaxed text-sky-light/80" data-id="element-172" data-mp="2a579ljdnx01q">
        A practical treatment-planning framework for dental professionals who want to organize complex orthodontic cases with greater
        clarity and consistency.
      </p>
      <p className="mt-6 text-xs text-sky-light/70" data-id="element-173" data-mp="1heyphlzkg5ki">© 2026 · Dr. Nathan Brooks · Ortho Treatment Map™ · All rights reserved.</p>
    </footer>;
}